/* close.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <polygon class="foreground-gl" points="16,0.8 15.2,0 8,7.2 0.8,0 0,0.8 7.2,8 0,15.2 0.8,16 8,8.8 15.2,16 16,15.2 8.8,8 "/>
            </svg>
         `,
};
